import request from '@/utils/request'

export function login(query) {
  return request({
    url: '/webUser/WebMechanismLogin',
    method: 'post',
    data: query
  })
}

export function loginByUsername(username, password) {
  const data = {
    username,
    password
  };
  return request({
    url: '/webUser/updatePassword',
    method: 'post',
    data
  })
//  /oauthToken/getToken
}

export function logout(query) {
  return request({
    url: '/webUser/logout',
    method: 'get',
    params:query
  })
}

export function getUser(token) {
  return request({
    url: '/webUser/Mechanism/getInfo',
    method: 'get',
    params: { token }
  })
}

export function getCount(query) {
  return request({
    url: '/webUser/WebUserHandle/countVisit',
    method: 'get',
    params:query
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js